import React from "react";

import type { SolverPhaseNeedsDayItem, SolverPhaseNeedsHeaderDayItem } from "@/components/sections/SolverPhaseNeeds.types.tsx";

export type RoleDayGridRow = {
    name: string;
    id: string;
    days: SolverPhaseNeedsDayItem[];
    isAll: boolean;
};

export type RoleDayGridExtraColumn = {
    header: string;
    renderCell: (roleId: string) => React.ReactNode;
};

export type RoleDayGridProps = {
    headerDays: SolverPhaseNeedsHeaderDayItem[];
    listOfUINeeds: RoleDayGridRow[];
    onRoleDayClick: (roleId: string, dayId: string) => void;
    onRoleAllDaysClick: (roleId: string) => void;
    // Optional column rendered between the role name and the days.
    extraColumn?: RoleDayGridExtraColumn;
};

const DAY_COL_WIDTH = "3rem";

const RoleDayGrid: React.FC<RoleDayGridProps> = (props) => {
    return (
        <table className="table-auto border-collapse border border-gray-300 w-full">
            <thead>
                <tr className="bg-gray-100">
                    <td className="border border-gray-300 px-4 py-2">{"Rôle"}</td>
                    {props.extraColumn && (
                        <td className="border border-gray-300 px-4 py-2 text-center font-semibold">{props.extraColumn.header}</td>
                    )}
                    {
                        props.headerDays.map((day) => {
                            return <td key={day.id} className="border border-gray-300 px-4 py-2" style={{ width: DAY_COL_WIDTH }}>{day.label}</td>
                        })
                    }
                    <td className="border border-gray-300 px-4 py-2" style={{ width: DAY_COL_WIDTH }}>{"Tout"}</td>
                </tr>
            </thead>
            <tbody>
                {
                    props.listOfUINeeds.map((item) => {
                        return <tr key={item.id}>
                            <td className="border border-gray-300 px-4 py-2 align-middle ">{item.name}</td>
                            {props.extraColumn && (
                                <td className="border border-gray-300 px-2 py-1 align-middle">{props.extraColumn.renderCell(item.id)}</td>
                            )}
                            {
                                item.days.map((day) => {
                                    return <td
                                        key={day.id}
                                        onClick={() => { props.onRoleDayClick(item.id, day.id) }}
                                        className="border border-gray-300 px-4 py-2 align-middle text-center text-xl font-bold cursor-pointer"
                                        style={{ width: DAY_COL_WIDTH, opacity: day.value ? 1 : 0.2 }}>
                                        {"✓"}
                                    </td>
                                })
                            }
                            <td
                                onClick={() => { props.onRoleAllDaysClick(item.id) }}
                                className="border border-gray-300 px-4 py-2 text-center text-xl font-bold cursor-pointer"
                                style={{ width: DAY_COL_WIDTH, opacity: item.isAll ? 1 : 0.2 }}>
                                {"✓"}
                            </td>
                        </tr>
                    })
                }
            </tbody>
        </table>
    );
};

export default RoleDayGrid;
